angular.module('shbdeployer.docker').controller('SecretController', [
  '$scope',
  '$transition$',
  '$state',
  'SecretService',
  'Notifications',
  function ($scope, $transition$, $state, SecretService, Notifications) {
    $scope.removeSecret = function removeSecret(secretId) {
      SecretService.remove(secretId)
        .then(function success() {
          Notifications.success('Секрет успешно удален');
          $state.go('docker.secrets', {});
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось удалить секрет');
        });
    };

    function initView() {
      SecretService.secret($transition$.params().id)
        .then(function success(data) {
          $scope.secret = data;
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось получить сведения о секрете');
        });
    }

    initView();
  },
]);
